import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import FlagVersion from 'components/FlagVersion';
import React from 'react';
import { Link } from 'react-router-dom';
import LoginDownBar from './components/LoginDownBar';
import styles from './styles';

export interface LinkButton {
  name: string;
  url: string;
  external?: boolean;
}

interface Props {
  children: React.ReactNode;
  imageWrapper: React.ReactNode;
  logoUrl: string;
  changeLanguage?: React.ReactNode;
  links?: LinkButton[];
  overrideClasses?: any;
}

const LoginPage: React.FC<Props> = ({
  children,
  imageWrapper,
  logoUrl,
  changeLanguage,
  links,
  overrideClasses,
}) => {
  const theme = useTheme();

  const classes = makeStyles(styles(theme, overrideClasses))();

  return (
    <Grid container className={classes.root}>
      <FlagVersion />
      <Hidden mdDown>
        <Grid
          container
          item
          lg={12}
          className={classes.appBar}
          justifyContent={changeLanguage ? 'space-between' : 'flex-start'}
        >
          <Grid item className={classes.logoWrapper}>
            <Link to="/" className={classes.hrefLogoWrapper}>
              <img
                src={logoUrl}
                alt="Logo"
                className={classes.logo}
                width={150}
              />
            </Link>
          </Grid>
          {changeLanguage && (
            <Grid item className={classes.logoWrapper}>
              {changeLanguage}
            </Grid>
          )}
        </Grid>
      </Hidden>

      {imageWrapper}

      <Grid
        container
        item
        xs={12}
        lg={6}
        alignContent="space-between"
        justifyContent="center"
      >
        <Grid
          container
          justifyContent="center"
          alignContent="center"
          alignItems="center"
          className={classes.loginWrapper}
        >
          {children}
        </Grid>

        <Grid
          container
          item
          xs={12}
          className={classes.copyrightWrapper}
          alignContent="center"
          alignItems="center"
        >
          <LoginDownBar links={links} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default withWidth()(LoginPage);
